export const omneaDataGridClasses = {
  roundTop: 'omnea-DataGrid--roundTop',
  roundBottom: 'omnea-DataGrid--roundBottom',
  roundHeaderRowTop: 'omnea-DataGrid--roundHeaderRowTop',
  roundPinnedLeftHeaderTop: 'omnea-DataGrid--roundPinnedLeftHeaderTop',
  roundFirstChildTop: 'omnea-DataGrid--roundFirstChildTop',
  allowPageScroll: 'omnea-DataGrid--allowPageScroll',
  clickableRows: 'omnea-DataGrid--clickableRows',
  highlightedCell: 'omnea-DataGrid--highlightedCell',
} as const

// We use a data- attribute here a) so we can only have one and b) so that consumers can verify that they have applied the style correctly
export const dataGridRowVariantAttribute = 'data-row-variant'

export type OmneaDataGridRowVariant = 'muted' | 'warning' | 'danger'

// Set by DataGridBase rather than by consumers: grouping rows are structure, not data.
export const dataGridGroupingRowVariant = 'grouping'
